import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var LinkedinCircleDark = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 44c12.15 0 22-9.85 22-22S34.15 0 22 0 0 9.85 0 22s9.85 22 22 22Zm-6.815-32.274a3.092 3.092 0 0 1-6.185 0 3.092 3.092 0 0 1 3.092-3.09 3.086 3.086 0 0 1 3.093 3.09ZM36 24.434v9.537a.429.429 0 0 1-.429.429h-4.924a.429.429 0 0 1-.43-.429v-8.867c0-2.331-.83-3.93-2.93-3.93-1.6 0-2.548 1.072-2.968 2.117-.152.375-.188.884-.188 1.41v9.28a.429.429 0 0 1-.429.428h-4.924a.429.429 0 0 1-.43-.429l.004-.895c.015-3.548.054-13.182.006-15.617a.418.418 0 0 1 .429-.428h4.915c.232 0 .43.187.43.428v2.036a.184.184 0 0 1-.019.027l-.018.027h.036v-.054c.769-1.178 2.136-2.866 5.21-2.866C33.15 16.62 36 19.102 36 24.434ZM9.804 34.4h4.925a.429.429 0 0 0 .429-.429v-16.52a.429.429 0 0 0-.429-.43H9.804a.429.429 0 0 0-.429.43v16.52c0 .241.188.429.43.429Z",
    svgColor: "#302C41"
  }));
});
LinkedinCircleDark.displayName = 'LinkedinCircleDark';
LinkedinCircleDark.defaultProps = {
  'aria-label': 'LinkedinCircleDark'
};
export default LinkedinCircleDark;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Logo/LinkedinCircleDark.js
// module id = 3580
// module chunks = 11